import createCachedSelector from 're-reselect'
import { selectPlans } from './selectPlans'
import { selectPreferredBillingVersionByProduct } from './selectPreferredBillingVersionByProduct'

export const selectIsPlanLegacy = createCachedSelector(
  selectPreferredBillingVersionByProduct,
  selectPlans,
  (_state, planId) => planId,
  (_state, _planId, product) => product,
  (accountBillingVersionByProduct, plans, planId, product) => {
    if (!planId || !product) return false

    const preferredVersion = accountBillingVersionByProduct[product]

    if ([null, undefined].includes(preferredVersion)) return false

    const plan = plans.find(p => p.planId === planId && p.product === product)

    if (!plan) return false

    return plan?.version !== preferredVersion
  }
)((_state, planId, product) => `${planId || 'unknown'}-${product || 'unknown'}`)
